import React, { useEffect, useState, createContext, useContext } from 'react';
interface NegotiationContextType {
  hasSubmittedOffer: boolean;
  negotiationCompleted: boolean;
  selectedTab: string;
  setHasSubmittedOffer: (value: boolean) => void;
  setNegotiationCompleted: (value: boolean) => void;
  setSelectedTab: (value: string) => void;
}
const defaultState: NegotiationContextType = {
  hasSubmittedOffer: false,
  negotiationCompleted: false,
  selectedTab: 'overview',
  setHasSubmittedOffer: () => {},
  setNegotiationCompleted: () => {},
  setSelectedTab: () => {}
};
const NegotiationContext = createContext<NegotiationContextType>(defaultState);
export const useNegotiation = () => useContext(NegotiationContext);
export const NegotiationProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  // Initialize state from localStorage if available
  const [hasSubmittedOffer, setHasSubmittedOffer] = useState<boolean>(() => {
    const saved = localStorage.getItem('hasSubmittedOffer');
    return saved ? JSON.parse(saved) : false;
  });
  const [negotiationCompleted, setNegotiationCompleted] = useState<boolean>(() => {
    const saved = localStorage.getItem('negotiationCompleted');
    return saved ? JSON.parse(saved) : false;
  });
  const [selectedTab, setSelectedTab] = useState<string>(() => {
    const saved = localStorage.getItem('selectedTab');
    return saved || 'overview';
  });
  // Update localStorage when state changes
  useEffect(() => {
    localStorage.setItem('hasSubmittedOffer', JSON.stringify(hasSubmittedOffer));
  }, [hasSubmittedOffer]);
  useEffect(() => {
    localStorage.setItem('negotiationCompleted', JSON.stringify(negotiationCompleted));
  }, [negotiationCompleted]);
  useEffect(() => {
    localStorage.setItem('selectedTab', selectedTab);
  }, [selectedTab]);
  return <NegotiationContext.Provider value={{
    hasSubmittedOffer,
    negotiationCompleted,
    selectedTab,
    setHasSubmittedOffer,
    setNegotiationCompleted,
    setSelectedTab
  }} data-id="element-34">
      {children}
    </NegotiationContext.Provider>;
};